"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _TopicMetadata = _interopRequireDefault(require("./TopicMetadata"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var TopicHeader = function TopicHeader(props) {
  var user = props.user,
      userTitle = props.userTitle,
      hideCategoryMetadata = props.hideCategoryMetadata,
      categoryUrl = props.categoryUrl,
      categoryName = props.categoryName,
      contentType = props.contentType;
  return (0, _preact.h)("div", {
    className: "topic-view_header"
  }, (0, _preact.h)("div", {
    className: "topic-view_header-item"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: user,
    extraClass: "avatar",
    showRank: true
  })), (0, _preact.h)(_TopicMetadata.default, {
    user: user,
    userTitle: userTitle,
    categoryUrl: categoryUrl,
    categoryName: categoryName,
    hideCategoryMetadata: hideCategoryMetadata,
    contentType: contentType
  }));
};

var _default = TopicHeader;
exports.default = _default;